const benefit_schedule_ch = `
<!DOCTYPE html
  PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <title>VHIS_Standard_Plan_-_Benefit_Schedule_(CN)</title>
  <style type="text/css">
    * {
      margin: 0;
      padding: 0;
      text-indent: 0;
    }

    .s1 {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
    }

    .s2 {
      color: black;
      font-family: "Heiti SC", sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 12pt;
    }

    .s3 {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
    }

    .s4 {
      color: black;
      font-family: "Heiti SC", sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 12pt;
    }

    .s5 {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
      vertical-align: 3pt;
    }

    .s6 {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
    }

    p {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
      margin: 0pt;
    }

    .h1 {
      color: black;
      font-family: "Heiti SC", sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 15pt;
    }

    .h2 {
      color: black;
      font-family: "Heiti SC", sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 12pt;
    }

    .s7 {
      color: black;
      font-family: "Heiti SC", sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 12pt;
    }

    .s8 {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
    }

    .s9 {
      color: black;
      font-family: "Arial Unicode MS", sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 12pt;
    }

    li {
      display: block;
    }

    #l1 {
      padding-left: 0pt;
      counter-reset: c1 1;
    }

    #l1>li:before {
      counter-increment: c1;
      content: "("counter(c1, decimal)") ";
      color: black;
      font-family: "Times New Roman", serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 10.5pt;
    }

    #l1>li:first-child:before {
      counter-increment: c1 0;
    }

    .new-page {
      page-break-before: always;
    }

    .header__container {
      float: left;
      display: block;
      width: 100%;
      margin: 0 0 25px 0;
    }

    .header__image {
      width: 100%;
    }
  </style>
</head>

<body>

  <p class="s1" style="margin-top: 50pt;text-indent: 0pt;text-align: center;">延愛</p>
  <p class="s1" style="padding-top: 7pt;text-indent: 0pt;text-align: center;">標準計劃保障表</p>
  <p style="text-indent: 0pt;text-align: left;"><br /></p>
  <p style="text-indent: 0pt;text-align: left;"><br /></p>
  <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
    <tr style="height:13pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        bgcolor="#A7A8A7">
        <p class="s2" style="padding-left: 23pt;text-indent: 0pt;line-height: 12pt;text-align: left;">保障項目<span
            class="s3">(1)</span></p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        bgcolor="#A7A8A7">
        <p class="s2" style="padding-left: 23pt;text-indent: 0pt;line-height: 11pt;text-align: left;">賠償限額（港元）
        </p>
      </td>
    </tr>
    <tr style="height:35pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(a) 病房及膳食
        </p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每日 $750</p>
        <p class="s3" style="padding-top: 1pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span
            class="s4">保單年度</span>最多 180 日</p>
      </td>
    </tr>
    <tr style="height:23pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(b) 雜項開支</p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span class="s4">保單年度</span>$14,000
        </p>
      </td>
    </tr>
    <tr style="height:30pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(c) 主診醫生巡房費
        </p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每日 $750</p>
        <p class="s3" style="padding-top: 1pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span
            class="s4">保單年度</span>最多 180 日</p>
      </td>
    </tr>
    <tr style="height:16pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(d) <span class="s4">專科醫生</span>費(2)
        </p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span class="s4">保單年度</span>$4,300
        </p>
      </td>
    </tr>
    <tr style="height:31pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(e) 深切治療</p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每日 $3,500</p>
        <p class="s3" style="padding-top: 1pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span
            class="s4">保單年度</span>最多 25 日</p>
      </td>
    </tr>
    <tr style="height:70pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(f) <span class="s4">外科醫生</span>費</p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 40pt;text-indent: -17pt;line-height: 111%;text-align: left;">
          每項手術，按手術表劃分的手術分類</p>
        <p class="s3" style="padding-left: 40pt;text-indent: 0pt;text-align: left;">複 雜 $50,000</p>
        <p class="s3" style="padding-left: 40pt;text-indent: 0pt;text-align: left;">大 型 $25,000</p>
        <p class="s3" style="padding-top: 1pt;padding-left: 40pt;text-indent: 0pt;text-align: left;">中 型 $12,500
        </p>
        <p class="s3" style="padding-top: 2pt;padding-left: 40pt;text-indent: 0pt;text-align: left;">小 型 $ 5,000
        </p>
      </td>
    </tr>
    <tr style="height:15pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(g) <span class="s4">麻醉科醫生</span>費
        </p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s4" style="padding-left: 23pt;text-indent: 0pt;line-height: 13pt;text-align: left;">外科醫生<span
            class="s3">費的 35%</span><span class="s5">(5)</span></p>
      </td>
    </tr>
    <tr style="height:14pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(h) 手術室費</p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s4" style="padding-left: 23pt;text-indent: 0pt;line-height: 13pt;text-align: left;">外科醫生<span
            class="s3">費的 35%</span><span class="s5">(5)</span></p>
      </td>
    </tr>
    <tr style="height:28pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(i) <span class="s4">訂明診斷成像檢測
          </span><span class="s6">(2) (3)</span></p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;line-height: 12pt;text-align: left;">每<span
            class="s4">保單年度 </span>$20,000</p>
        <p class="s3" style="padding-top: 1pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">設 30% <span
            class="s4">共同保險</span></p>
      </td>
    </tr>
    <tr style="height:18pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">(j) <span
            class="s4">訂明非手術癌症治療</span><span class="s5">(4)</span></p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span class="s4">保單年度
          </span>$80,000</p>
      </td>
    </tr>
    <tr style="height:46pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3"
          style="padding-left: 21pt;padding-right: 25pt;text-indent: -15pt;line-height: 114%;text-align: left;">
          (k) 入院前或出院後 / <span class="s4">日間手術</span>前後的門診護理(2)</p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
          每次$580，每<span class="s4">保單年度</span>$3,000</p>
        <p class="s4" style="padding-left: 40pt;text-indent: 0pt;text-align: left;">住院<span class="s3">/
          </span>日間手術<span class="s3">前最多1 次門診或</span>急症<span class="s3">診症出院/</span></p>
        <p class="s4" style="padding-top: 1pt;padding-left: 40pt;text-indent: 0pt;text-align: left;">日間手術<span
            class="s3">後90 日內最多3 次跟進門診</span></p>
      </td>
    </tr>
    <tr style="height:18pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(l) 精神科治療
        </p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span class="s4">保單年度
          </span>$30,000</p>
      </td>
    </tr>
    <tr style="height:18pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s2" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">其他限額</p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p style="text-indent: 0pt;text-align: left;"><br /></p>
      </td>
    </tr>
    <tr style="height:18pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">保障項目(a) – (l) 的<span
            class="s4">每年保障限額</span></p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 2pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">每<span
            class="s4">保單年度 </span>$420,000</p>
      </td>
    </tr>
    <tr style="height:18pt">
      <td
        style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">保障項目(a) – (l) 的<span
            class="s4">終身保障限額</span></p>
      </td>
      <td
        style="width:291pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s3" style="padding-top: 1pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">無</p>
      </td>
    </tr>
  </table>
  <p style="text-indent: 0pt;text-align: left;"><br /></p>
  <table style="width: 650px; margin-left: auto; margin-right: auto;">
    <tr>
      <td>
        <p style="padding-top: 5pt;padding-left: 27pt;text-indent: 0pt;line-height: 14pt;text-align: left;">註解
        </p>
        <ol id="l1">
          <li style="padding-left: 27pt;line-height: 15pt;text-align: left;">
            <p style="display: inline;">同一項目的<span class="h1">合資格費用</span>不可獲上述表中多於一個保障項目的賠償。</p>
          </li>
          <li style="padding-left: 27pt;line-height: 124%;text-align: left;">
            <p style="display: inline;"><span class="h2">本公司</span>有權要求有關書面建議的證明，例如轉介信或由主診醫生或<span
                class="h1">註冊醫生</span>在索償申請表內提供的陳述。</p>
          </li>
          <li style="padding-left: 27pt;line-height: 13pt;text-align: left;">
            <p style="display: inline;">檢測只包括電腦斷層掃描（“CT”掃描）、磁力共振掃描（“MRI”掃描）、正電子放射斷層掃描（“PET”掃描）、PET–CT 組合及
              PET–MRI 組合。</p>
          </li>
          <li style="padding-left: 27pt;line-height: 14pt;text-align: left;">
            <p style="display: inline;">治療只包括放射性治療、化療、標靶治療、免疫治療及荷爾蒙治療。</p>
          </li>
          <li style="padding-left: 27pt;line-height: 124%;text-align: left;">
            <p style="display: inline;">此百分比適用於<span class="h1">外科醫生</span>費實際賠償的金額或根據手術分類下<span
                class="h1">外科醫生</span>費的保障限額，以較低者為準。</p>
          </li>
        </ol>
      </td>
    </tr>
  </table>

  <div class="new-page"></div>


  <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">手術表</p>
  <p style="text-indent: 0pt;text-align: left;"><br /></p>
  <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
    <tr style="height:17pt">
      <td
        style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        colspan="2" bgcolor="#C0C0C0">
        <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        bgcolor="#C0C0C0">
        <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        colspan="3" bgcolor="#F2F2F2">
        <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹部及消化系統</p>
      </td>
    </tr>
    <tr style="height:15pt">
      <td
        style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        rowspan="17">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 5pt;padding-right: 10pt;text-indent: 0pt;line-height: 126%;text-align: left;">
          食道、胃及十二指腸</p>
      </td>
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">食道病變組織切除術/
          經頸進行食道病變組織或組織破壞術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">高選擇性胃迷走神經切斷術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡胃底摺叠術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡式食道裂孔疝氣修補術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:29pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;padding-right: 5pt;text-indent: 0pt;line-height: 14pt;text-align: left;">
          食道胃十二指腸內窺鏡檢查，連或不連活體組織檢查及 / 或息肉切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">食道胃十二指腸內窺鏡檢查連異物清除</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">食道胃十二指腸內窺鏡連食道 / 胃靜脈曲張結紥 / 綁紥術
        </p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          中型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">食道切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">食道全切除術及腸插入手術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經皮膚進行胃造口術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">永久胃切開術/ 胃腸造口術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分胃切除術連或不連空腸移位術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分胃切除術連十二指腸/ 空腸接合術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分胃切除術連接合食道術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:29pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-left: 5pt;padding-right: 13pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
          近端胃切除術/ 根治性胃切除術/ 全部胃切除術連或不連腸插入術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">十二指腸撕裂縫合術/ 十二指腸潰瘍修補術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胃迷走神經切斷術及/ 或幽門成形術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
        rowspan="15">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 5pt;padding-right: 10pt;text-indent: 0pt;line-height: 128%;text-align: left;">
          空腸、迴腸及大腸</p>
      </td>
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式闌尾炎切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          中型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肛裂切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肛瘻管切開術或切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          中型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肛周膿腫的切除術及引流術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">修補直腸脫垂的德洛姆手術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">結腸鏡檢查連或不連活體組織檢查</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">結腸鏡檢查，連息肉切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">乙狀結腸內窺鏡檢查</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外痔或內痔切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          中型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">痔瘡的注射療法或綁紮術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
          小型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">迴腸造口術或結腸造口術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          大型</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式直腸前位切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式經腹部會陰切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式結腸切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
    <tr style="height:17pt">
      <td
        style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式直腸低前位切除術</p>
      </td>
      <td
        style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
        <p class="s8"
          style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
          複雜</p>
      </td>
    </tr>
  </table>

  <div class="new-page"></div>


  <table style="text-align:center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto; text-align:center;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腸扭結或腸套疊復位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">小腸切除術及接合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="3">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膽管</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式膽囊切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">逆行內窺鏡膽胰管造影術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
            逆行內窺鏡膽胰管造影術連乳突物手術、膽結石摘取或其他</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">相關手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 10pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="7">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肝臟</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">幼針抽吸肝活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肝移植手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">開放式肝病變組織 /
            肝囊腫或肝膿腫袋形縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式移除肝病變組織</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式肝次葉切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式肝葉切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式肝揳形切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="3">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胰臟</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">閉合式胰管活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胰臟 / 胰管病變組織或組織的切除術或破壞術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胰臟十二指腸切除術（惠普爾手術）</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="6">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">腹部</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">剖腹探查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡檢查 / 腹膜內窺鏡檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式的單側疝切開/ 縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式的兩側疝切開/ 縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式的單側腹腔溝疝修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式的兩側腹腔溝疝修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦部及中樞神經系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="13">
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">神經外科手術</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦部活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱骨鑽孔術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱骨切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱神經減壓術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦室引流沖洗術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦室引流的維修清除術，包括修正術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            建立腦室腹腔引流或皮下腦脊液儲存器</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱內動脈瘤鉗夾術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱內動脈瘤包裹術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱內動靜脈血管畸型切除手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">聽覺神經瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦腫瘤或腦膿腫切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顱神經腫瘤切除手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align:center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="5">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">治療三叉神經節氣囊的射頻溫熱凝固術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">使用射頻進行閉合式三叉神經根切斷術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">三叉神經根減壓術 / 開放式三叉神經根切斷術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">大腦包括腦葉切除手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">大腦半球切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="5">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">脊椎手術</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腰椎穿刺或小腦延髓池穿刺手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脊髓或脊神經根減壓術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">頸交感神經切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胸腔鏡或腰交感神經切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脊髓管内硬膜内或硬膜外的腫瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心血管系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="13">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">心臟</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心臟導管插入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">冠狀動脈分流手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心臟移植</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心臟起膊器置入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心包穿刺術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心包切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:29pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 5pt;padding-right: 6pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            經皮刺穿冠狀動脈腔內成形術及有關程序，包括：激光、支架置入、馬達扇頁切割、氣囊擴張或射頻切割技術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">肺動脈瓣切開術、氣囊/
            腔內激光/ 腔內射頻術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經皮心瓣成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">主動脈瓣擴張術/ 二尖瓣切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">閉合式心瓣切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心臟直視心瓣成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">心瓣置換</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p class="s8" style="padding-top: 2pt;padding-left: 8pt;text-indent: 0pt;text-align: left;">血管</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹內動脈/ 脾靜脈腎靜脈/ 門靜脈腔靜脈分流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">腹腔血管切除術連置換/
            接合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">内分泌系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腎上腺</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡式或腹膜後腔鏡式單側腎上腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡式或腹膜後腔鏡式兩側腎上腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">松果腺</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">松果腺全切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦下垂體</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腦下垂體腫瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">甲狀腺</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">幼針抽吸甲狀腺活組織檢查連或不連影像導引</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:33pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;padding-right: 6pt;text-indent: 0pt;text-align: left;">半甲狀腺切除術/
            部分甲狀腺切除術 / 大部分甲狀腺切除術/ 副甲狀腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 11pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">甲狀腺全切除術/
            副甲狀旁腺全切除術 / 機械人輔助式甲狀</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">腺全切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 10pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">甲狀舌管囊腫切除術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">耳鼻喉 / 呼吸系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="16">
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">耳</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">耳道閉鎖/ 耳道狹窄的耳道成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">耳前囊腫/ 耳前竇切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">耳廓血腫引流/ 裝鈕/ 切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">耳道成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">（耳科）異物清除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">切開鼓室進行中耳腫瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼓膜切開術連或不連導管插入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼓膜成形術 / 鼓室成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">聽小骨成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">全部 / 部分迷路切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">乳突切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">耳蝸手術及 / 或人工耳蝸植入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">內淋巴囊手術/ 內淋巴囊減壓術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">圓窗或卵圓窗瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼓室交感神經切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">前庭神經切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="15">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻、口及咽喉</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">上頜竇穿刺及沖洗術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻粘膜燒灼術/ 鼻衂控制</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻骨折閉合復位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">口竇瘻管閉合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淚囊鼻腔造口術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻病變組織切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
            鼻咽鏡檢查或鼻鏡檢查連或不連鼻腔活體組織檢查連或不連</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">清除異物</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 10pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻瘜肉切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">考一路二氏手術/
            以考一路二氏式進行/ 上頜竇切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">篩竇 / 上頜竇/ 額竇 / 蝶竇內窺鏡手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            延伸性額竇內窺鏡手術連經中隔的額竇切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">額竇切開術或篩竇切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">額竇切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">功能性鼻竇內窺鏡手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">兩側功能性鼻竇內窺鏡手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="19">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">上頜竇/ 蝶竇/ 篩竇動脈結紮術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
            其他鼻內手術，包括激光手術（除了簡易的鼻鏡檢查、活體</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">組織檢查及血管燒灼術）
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 10pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻咽腫瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">竇腔鏡連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻中隔成形術連或不連黏膜下層切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻中隔黏膜下層切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鼻甲切除術 / 粘膜下鼻甲切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腺樣體切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">扁桃體切除術連或不連腺樣體切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">咽囊 / 咽憩室切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">咽成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:49pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
            治療睡眠相關呼吸疾病的舌骨懸吊術、上顎 / 下顎/ 舌頭前</p>
          <p class="s8"
            style="padding-top: 2pt;padding-left: 5pt;padding-right: 4pt;text-indent: 0pt;line-height: 15pt;text-align: left;">
            移術、激光懸吊術 / 切除術、射頻切割輔助垂腭咽成形術、垂腭咽成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
          <p class="s8" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">治療舌下囊腫的袋形縫合術 / 切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">表層腮腺清除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腮腺清除術 / 腮腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">下頜唾腺液清除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">下頜腺導管移位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">下頜腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="13">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">呼吸系統</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">杓狀軟骨半脫位– 喉鏡復位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">支氣管鏡檢查連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">支氣管鏡連清除異物</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">喉鏡檢查連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">喉頭 / 氣管狹窄 –
            喉内 / 開放式支架置入術 / 重建術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">喉頭分流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">喉切除術連或不連根治性頸淋巴組織切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:33pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">喉顯微鏡檢查連或不連活體組織檢查，連或不連小結 / 息肉
          </p>
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">/ 聲帶水腫切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 10pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">喉腫瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">會厭窩囊腫清除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">喉骨折修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">治療聲帶麻痺注射法</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">氣管食道穿刺術進行語音復建</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="10">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">治療聲帶麻痺的甲狀軟骨成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">聲帶手術包括使用激光技術（惡性腫瘤除外）</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">氣管造口術 – 臨時性 / 永久性 / 修正術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肺葉切除術 / 肺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胸膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肺節段切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">治療氣胸的胸腔穿刺術/ 胸管插入術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胸腔鏡連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胸廓成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胸腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼部</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="25">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼瞼損傷組織切除術 / 刮除術 / 冷凍治療</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼瞼縫合術 / 眼緣縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">瞼內翻或瞼外翻修補術連或不連楔型切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分皮層眼瞼重建術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">結膜損傷組織切除術 / 破壞術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">胬肉切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            角膜移植術、嚴重傷口修復及角膜成形術，包括角膜移植</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">激光清除術或角膜損傷組織破壞術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">角膜異物清除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">角膜修復手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">角膜撕裂或受傷的縫補術 / 修補術連結膜移位</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">晶狀體囊抽吸術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">晶狀體囊切開術，包括使用激光</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">囊外 / 囊內晶狀體摘除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">去除眼內晶狀體/ 植入物</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">為脈絡膜視網膜損傷組織進行的手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">白內障超聲乳化手術連人工晶體植入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">氣體視網膜粘結術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">視網膜光凝固療法</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">視網膜脫落 / 撕裂的修補手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">視網膜撕裂 / 脫落的修補術連扣帶術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">視網膜脫落扣帶術 / 環紮術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睫狀體分離術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">小梁切除術，包括使用激光</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">青光眼手術治療包括置入植入物</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="27">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">玻璃體診斷性抽吸術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">注入玻璃體替代物</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">玻璃體切除術 / 移除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">虹膜活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">虹膜 / 眼前半段 / 睫狀體損傷組織切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脫垂虹膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">虹膜切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">虹膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">激光虹膜成形連或不連瞳孔成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">虹膜崁頓術及虹膜牽張術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鞏膜造瘻術連或不連虹膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">鞏膜熱灼術連或不連虹膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睫狀體縮減術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼外肌或肌腱活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">單一條眼外肌手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            眼球穿孔傷口連箝閉或眼色素膜脫落修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼球摘除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼球 / 眼內物摘除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">眼球或眼眶修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">結膜淚囊鼻腔造口術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">結膜淚囊鼻腔造口術連導管或支架插入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淚囊鼻腔造口術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淚囊及淚道切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淚腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淚小管/ 鼻淚管探查連或不連冲洗</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淚小管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">瞳孔成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">女性生殖系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="8">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸截除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道鏡檢查連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸錐形切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:16pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">使用切除術 / 冷凍手術 / 燒灼術/
            激光破壞子宮頸病變組織</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸內膜刮除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸電環切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸囊腫袋形縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸/ 子宮/ 陰道撕裂縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="14">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">輸卵管及卵巢^</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">輸卵管擴張術/ 吹氣術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式切除/ 破壞輸卵管病變組織</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">輸卵管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">輸卵管造口術/ 輸卵管切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">全部或部分輸卵管切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">輸卵管成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">卵巢囊腫抽吸術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式卵巢囊腫切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式卵巢楔形切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">卵巢切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡式卵巢切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式輸卵管卵巢切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式輸卵管卵巢膿瘍引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:14pt">
        <td
          style="width:374pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2">
          <p class="s9" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: left;">^<span
              class="s8">除非另有說明，此類別應用於單側或兩側（輸卵管及卵巢）</span></p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="15">
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮頸擴張及刮宮術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">宮腔鏡檢查連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            宮腔鏡檢查連切除或破壞子宮及承重結構</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡輔助的陰道子宮切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:29pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;padding-right: 4pt;text-indent: 0pt;text-align: left;">
            經陰道切除子宮連或不連膀胱突出症及 / 或直腸突出症的修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
            開放式或腹腔鏡式經腹部切除全部/ 大部分子宮連或不連兩</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">側輸卵管卵巢切除術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 10pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經腹部進行根治性子宮切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式子宮肌瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經陰道或宮腔鏡切除子宮肌瘤</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡式盆腔膿腫引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道懸吊術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">盆腔底修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">盆腔臟器切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮懸吊術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:16pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="3">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">使用切除術 / 冷凍手術 / 燒灼術/
            激光破壞陰道病變組織</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道承托環的嵌入或移除</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">巴多林氏腺囊腫袋形縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="19">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道剝脫術或陰道斷端術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道部分切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道全切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">根治性陰道切除術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道前壁修補術使用或不使用基利氏聯針法</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道後壁修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道穹窿閉塞術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">骶棘韌帶懸吊或陰道固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">骶骨陰道固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經陰道進行腸疝修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尿道陰道瘻管閉合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經陰道進行直腸陰道瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經腹部進行直腸陰道瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">後穹窿穿刺術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">子宮直腸凹切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道橫隔切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">麥哥氏後穹窿整型術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">陰道重建術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:16pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="10">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外陰及入口</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 14pt;text-align: left;">使用切除術 /
            冷凍手術 / 燒灼術/ 激光破壞外陰病變組織</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">闊邊局部外陰冷刀切除術或子宮頸電環切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">前庭腺炎切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">切除外陰活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外陰及會陰切開術及引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外陰粘連鬆解術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外陰或會陰瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外陰及/ 或會陰撕裂縫合術 / 修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外陰切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">根治性外陰切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">血液淋巴系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="6">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淋巴結</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">淋巴結病變組織/ 膿腫引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:21pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">表面淋巴結活體組織檢查/ 切除/ 淋巴結構的單純切除術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 4pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            頸淋巴結切開活組織檢查/ 幼針抽吸淋巴結活組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">深淋巴結/ 淋巴管瘤/ 囊狀水瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">兩側腹股溝淋巴結切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">頸淋巴結切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="5">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹股溝及盤骨淋巴結切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">根治性腹股溝清掃術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">根治性盤腔淋巴結切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">選擇性/ 根治性 / 功能性頸淋巴切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腋淋巴結廣泛性切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脾臟</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式脾切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">男性生殖系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="8">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">前列腺</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">前列腺膿腫外部引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">激光前列腺氣化術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">等離子激光前列腺氣化術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">前列腺活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經尿道微波電療法</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經尿道前列腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式前列腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式根治性前列腺切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="3">
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">陰莖</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">包皮環切術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">痛性陰莖勃起鬆解術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">隱藏陰莖修補術/ 陰莖抽出術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="12">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">睾丸^</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">附睾切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睾丸探查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡探查未降睾丸</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睪丸固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腹腔鏡式睾丸切除術或睪丸固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睪丸扭轉復位及固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睾丸活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睪丸鞘膜積水高位結紮術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">睾丸鞘膜積水抽液手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">精索靜脈曲張及睪丸鞘膜積液切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">精索靜脈曲張切除術（顯微外科）</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:13pt">
        <td
          style="width:374pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2">
          <p class="s9" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: left;">^<span
              class="s8">如非特別說明，此類別應用於單側或兩側（睾丸）</span></p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">輸精管</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">輸精管結紮手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肌肉骨骼系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="4">
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">骨</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">單肢的手指 / 腳趾截肢術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">單臂 / 單手/ 單腿/ 單腳截肢術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">拇趾囊腫切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            拇趾囊腫切除術並進行軟組織矯正及第一蹠骨切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="8">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">橈骨頭切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">因良性疾病切除下頜骨</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膝蓋骨切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分面骨骨切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">面部死骨切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腕/ 手 / 腿骨的楔形截骨術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">上臂 / 下臂/ 大腿的楔形截骨術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肩胛骨/ 鎖骨/ 胸骨的楔形截骨術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="28">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">關節</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節鏡引流及清創手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節鏡移除關節內游離體</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節鏡檢查連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            關節鏡輔助進行韌帶重建術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節鏡班卡特修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:21pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經關節鏡肩關節上盂唇由前往後撕裂的修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 3pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節鏡旋轉套修復術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肩峰切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肩關節融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肘關節融合術/ 三關節融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膝關節/ 髖關節融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手 / 手指 / 足 / 足趾的關節置換連植入術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腕融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腕滑膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腳趾指骨間關節融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手指指骨間關節融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肩關節切除術 / 半肩關節置換術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">髖關節/ 膝關節 / 手腕關節 / 肘關節切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">髖關節/ 膝關節切除術連局部釋放抗生素</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顳顎關節成形術連或不連自體移植</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節抽吸術 / 注射</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">麻醉下進行關節鬆弛治療</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">金屬股骨頭置入術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">前十字韌帶重建術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或關節鏡式鏡半月板切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">後十字韌帶重建術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">副韌帶修復術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">十字韌帶修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="5">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">踝及足關節囊或韌帶的縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">全肩置換術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">全膝置換術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">全髖置換術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分髖關節置換術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="16">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肌肉及肌腱</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">跟腱修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">跟腱切斷術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:29pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;padding-right: 12pt;text-indent: 0pt;text-align: left;">
            肌肉或肌腱放鬆或收緊手術（除手部以外）/ 肌肉損傷組織切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 8pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手部肌肉或肌腱放鬆或收緊手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肌肉損傷組織切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肌腱延長，包括腱切斷術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式肌肉活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">橈骨莖突狹窄性腱鞘炎</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">板機指鬆解術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">網球肘（肱骨外上髁炎）鬆解術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肌肉轉移/ 移植 / 再接合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">不涉及手部的肌腱修復術 / 縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手肌腱修復術/ 縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腱鞘滑膜切除術/ 滑膜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手腕 / 手肌腱移位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">二期肌腱修補術，包括移植、轉移及 / 或假體置入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="12">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">骨折及脫位</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顳顎 / 指間骨/ 肩峰關節脫位閉合復位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:22pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肩膀 / 肘 / 腕 / 踝骨脫位閉合復位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 4pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">科雷氏骨折閉合復位術連經皮膚克氏缐固定治療</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:20pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手臂 / 腿骨/ 髕骨/ 盤骨骨折閉合復位術連內固定術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 3pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顎骨骨折閉合復位術連內固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">肩胛骨/ 鎖骨/ 指骨 / 髕骨骨折閉合復位術不連內固定術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:29pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 5pt;padding-right: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            上臂/ 前臂/ 手腕/ 手 / 腿 / 足骨骨折閉合復位術不連內固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">肩胛骨/ 手骨/ 踝骨
            / 足骨骨折閉合復位術連內固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">股骨骨折閉合復位術連或不連内固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">關節窩骨折閉合/ 開放復位術連内固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">顎骨骨折開放復位術連内固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">肩胛骨/ 手 /
            足骨骨折開放復位術（除腕骨/ 踝骨/ 跟骨</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">外） 連或不連內固定術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 11pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="4">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">手臂 / 腿骨/ 髕骨/
            鎖骨骨折開放復位術連或不連內固定術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">股骨 / 跟骨/ 踝骨骨折開放復位術連或不連内固定術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            使用外固定支架及徹底傷口清創術的複合性骨折手術治療</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:29pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 5pt;padding-right: 10pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            拆除因舊骨折而裝上的螺絲、釘、金屬板及其他金屬 (股骨除外)</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="14">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脊椎</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">人造頸椎間盤置換術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:16pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">頸 / 頸胸 / C4/5 及 C5/6
            前脊柱融合術連鎖定骨板</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">大型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">除頸 / 頸胸/
            C4/5 及 C5/6 以外的前脊柱融合術連鎖定骨板</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">前脊椎融合術連儀器設置</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">頸椎板成形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">椎板切除術或椎間盤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">椎板切除術連椎間盤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">胸 / 頸胸 /
            胸腰/ T5 至 L1 / 環 – 樞椎 後脊椎融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:29pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 5pt;padding-right: 3pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            （除胸/ 頸胸/ 胸腰 / T5 至 L1 / 環 – 樞椎以外的）後脊椎融合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 9pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">後脊椎融合術連儀器設置
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脊椎活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 14pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:36pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
            脊椎融合術，連或不連椎間孔切開術，連或不連椎板切除</p>
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">術，連或不連椎間盤切除術
          </p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 11pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脊椎截骨術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">椎體成形術 / 椎體矯正術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="7">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">其他</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">神經節/ 滑囊切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">掌腱膜攣縮的閉合式 / 經皮膚刺針筋膜切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">掌腱膜攣縮的根治性或全部筋膜切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或內窺鏡式腕道或踝管鬆解術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">周圍神經鬆解術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尺神經移位術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">滑動式/ 復位式下巴整形術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">皮膚及乳房</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="8">
          <p class="s8" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">皮膚</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">皮膚或皮下病變組織切除術 / 冷凍術 / 電灼術 /
            激光治療</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">指甲下血腫或膿腫引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">脂肪瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">用於移植的切皮手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">皮膚膿腫切開術及 / 或引流術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">皮膚及/ 或皮下組織切開術及 / 或異物清除</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:15pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
            皮膚及皮下病變組織的局部切除術或破壞術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">皮膚傷口縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="2">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">外科洗滌及縫合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">趾甲楔形切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="9">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">乳房</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">乳房腫瘤/ 腫塊切除術連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">幼針抽吸乳房囊腫檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">乳房活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">改良式根治性乳房切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分或簡易乳房切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分或根治性乳房切除連腋窩淋巴切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">全部或根治性乳房切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">乳管內乳頭狀瘤切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">男性乳腺增生切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">泌尿系統</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="8">
          <p class="s8" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">腎臟</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">因泌尿系統結石進行的體外衝擊波碎石術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腎石切除術 / 腎盂切開術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腎內窺鏡</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經皮膚插入腎造口管手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腎活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或使用腹腔鏡或後腹腔鏡的腎切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">部分 / 下端腎切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">腎移植手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="15">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 5pt;padding-right: 10pt;text-indent: 0pt;line-height: 126%;text-align: left;">
            膀胱、輸尿管及尿道</p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膀胱鏡檢查連或不連活體組織檢查</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膀胱鏡連輸尿管導管插入/ 經尿道膀胱清除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膀胱鏡連電灼術/ 激光碎石術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尿道肉阜切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尿道或尿管支架植入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            中型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式膀胱憩室切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">經尿道切除膀胱腫瘤</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式部分膀胱切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或腹腔鏡式根治性/ 全部膀胱切除術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">開放式或使用腹腔鏡或後腹腔鏡的尿管切石術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尿道直腸瘻管閉合術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尿道瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">膀胱陰道瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">結腸膀胱瘻管修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">尿道破裂修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
    </table>
  </table>

  <div class="new-page"></div>


  <table style="text-align: center;">
    <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
      <tr style="height:17pt">
        <td
          style="width:382pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="2" bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">程序 / 手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          bgcolor="#C0C0C0">
          <p class="s7" style="padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">分類</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          rowspan="5">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">應力性尿失禁修補術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">迴腸導管建造，包括輸尿管植入</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            複雜</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">迴腸或結腸代替輸尿管手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">單邊輸尿管再植入腸或膀胱</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">雙邊輸尿管再植入腸或膀胱</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            大型</p>
        </td>
      </tr>
      <tr style="height:17pt">
        <td
          style="width:457pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
          colspan="3" bgcolor="#F2F2F2">
          <p class="s7" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">牙科</p>
        </td>
      </tr>
      <tr style="height:18pt">
        <td
          style="width:83pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p style="text-indent: 0pt;text-align: left;"><br /></p>
        </td>
        <td
          style="width:299pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">任何因意外受傷而進行的牙科手術</p>
        </td>
        <td
          style="width:75pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s8"
            style="padding-top: 1pt;padding-left: 25pt;padding-right: 24pt;text-indent: 0pt;text-align: center;">
            小型</p>
        </td>
      </tr>
    </table>
  </table>
</body>

</html>
`

export { benefit_schedule_ch }
